module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/MobileHeroPoster-c8b575fbe6a366f828674b537df5a6d4.png";